import { Button, Form, Input, Modal } from "antd";

const CreateEditBulkEmailingSendersModal = ({
  isModalOpen = false,
  initialValues = {},
  setIsModalOpen = () => {},
  handleSenderCreateEdit = () => {}
}) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = (values) => {
    handleSenderCreateEdit(values);
  };

  return (
    <Modal
      title="Create New Sender"
      open={isModalOpen}
      footer={[]}
      onOk={handleOk}
      onCancel={handleCancel}
      width="1200px"
    >
      <Form
        form={form}
        name="create_sender_modal_form"
        initialValues={initialValues?.key !== undefined ? initialValues : {}}
        onFinish={handleFormSubmit}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter the name!"
            }
          ]}
        >
          <Input placeholder="This name will be visible as the email sender to the receiver." />
        </Form.Item>

        <Form.Item
          name="emailAddress"
          label="Email Address"
          rules={[
            {
              required: true,
              message: "Please enter the email address!"
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="backendKey"
          label="Backend Key (Ex: BULK_EMAILING_SENDER_SUPPORT)"
          rules={[
            {
              required: true,
              message: "Please select a backend key!"
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="purpose"
          label="Purpose"
          rules={[
            {
              required: true,
              message: "Please select a purpose of this email!"
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            {initialValues?.key !== undefined ? "Update" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default CreateEditBulkEmailingSendersModal;
